
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Building } from 'lucide-react';
import HotelSearch from '@/components/hotels/HotelSearch';
import { useIsMobile } from '@/hooks/use-mobile';

interface HotelsTabProps {
  tripId: string;
  isAuthorized: boolean;
}

const HotelsTab: React.FC<HotelsTabProps> = ({ tripId, isAuthorized }) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="w-full max-w-full overflow-x-visible">
      {isAuthorized ? (
        <HotelSearch tripId={tripId} />
      ) : (
        <Card className="w-full">
          <CardHeader className="pb-2">
            <div className="flex items-center">
              <Building className="h-5 w-5 mr-2 text-glowingTeal" />
              <CardTitle className="text-lg">Hotel Search</CardTitle>
            </div>
          </CardHeader>
          <CardContent>
            <div className="mt-4 text-center">
              <p className="text-muted-foreground">
                Only trip members can manage hotel details
              </p>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default HotelsTab;
